'use client'
import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {Button} from '@/components/ui/button';
import Image from "next/image";
import Link from "next/link";

export default function LangComponent() {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button className="flex place-items-center gap-2 p-3 lg:pointer-events-auto lg:p-0 ms-3"
                    variant="outline"
                >
                    <Image
                        src="/icon/globe.americas.fill.svg"
                        alt="github webgoodpeople Logo"
                        className="dark:invert"
                        width={32}
                        height={32}
                        priority
                    />
                    Ru
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent aria-label="Static Actions">
                <DropdownMenuItem asChild>
                    <Link href="/">English</Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}